var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91593 10.5646C1.80812 10.3939 1.75421 10.3086 1.72403 10.1769C1.70136 10.078 1.70136 9.92206 1.72403 9.82317C1.75421 9.69151 1.80812 9.60616 1.91593 9.43544C2.80688 8.02471 5.45886 4.45837 9.50032 4.45837C13.5418 4.45837 16.1938 8.02471 17.0847 9.43544C17.1925 9.60616 17.2464 9.69151 17.2766 9.82317C17.2993 9.92206 17.2993 10.078 17.2766 10.1769C17.2464 10.3086 17.1925 10.3939 17.0847 10.5646C16.1938 11.9754 13.5418 15.5417 9.50032 15.5417C5.45886 15.5417 2.80688 11.9754 1.91593 10.5646Z",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50032 12.375C10.812 12.375 11.8753 11.3117 11.8753 10C11.8753 8.68836 10.812 7.62504 9.50032 7.62504C8.18864 7.62504 7.12532 8.68836 7.12532 10C7.12532 11.3117 8.18864 12.375 9.50032 12.375Z",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.72f7e7d3e04a523f16cd0d3a8e100f28.svg";
export { ForwardRef as ReactComponent };